import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import DBNDomainBasicInfoComponent from './dbn-domain-basic-info.component';
import DBNDomainAccountMappings from './dbn-domain-account-mappings';

function DBNDomainComponent({
    handleInnerFormChange, selectedDBNDomain, domains, back, handleFormSubmit, id
}: any) {

    const tabItems = [
        {
            id: 0,
            title: 'DBN Domain',
            component: <DBNDomainBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedDBNDomain={selectedDBNDomain}
                domains={domains}
            />,
            isVisible: true,
        },
        {
            id: 1,
            title: 'Account Mappings',
            component: <DBNDomainAccountMappings
                id={id}
            />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                {/* <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button> */}
            </div>
        </div>
    );
}

export default DBNDomainComponent;
